import {Base} from "@/api/Base"

export class CheckToken extends Base {
    //此处修改后台登录用户的登录路径
    path = "employee/checkToken"
}